import Backpack from '@/src/assets/svgs/Backpack'
import { Luggage } from '@mui/icons-material'
import { Box, Tooltip, Typography } from '@mui/material'

const SegmentBaggage = ({
    cab,
    cib,
    freeText,
    viewBaggageCta,
    cabinBaggageCta,
    checkinBaggageCta
}: {
    cab: string
    cib: string
    freeText: string
    viewBaggageCta: string
    cabinBaggageCta: string
    checkinBaggageCta: string
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                fontSize: 12,
                color: 'textColors.secondary',
                alignItems: 'flex-start',
                marginTop: 0.5
            }}
        >
            {freeText ? (
                <Tooltip
                    title={freeText}
                    slotProps={{
                        tooltip: {
                            sx: {
                                bgcolor: 'common.black',
                                color: 'common.white',
                                fontSize: 12,
                                '& .MuiTooltip-arrow': {
                                    color: 'common.black'
                                }
                            }
                        }
                    }}
                >
                    <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                        {viewBaggageCta}
                    </Typography>
                </Tooltip>
            ) : (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Luggage sx={{ fontSize: 16, mr: 0.5 }} />
                        {checkinBaggageCta}:{' '}
                        <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                            {cib}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Backpack sx={{ fontSize: 16, mr: 0.5 }} />
                        {cabinBaggageCta}:{' '}
                        <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                            {cab}
                        </Typography>
                    </Box>
                </>
            )}
        </Box>
    )
}

export default SegmentBaggage
